import React from 'react';

import Header from './compenents/Header/header';
import Footer from './compenents/Footer/footer';
import Contact from './compenents/Contact/contact';
import Home from './compenents/Home/home';
import About from './compenents/About/about';
import Skills from './compenents/Skills/skills';
import Project from './compenents/Projects/project';


function App() {
  return (
    <div className="App">
      <Header />
      <Home />
      <About />
      <Skills />
      <Project />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
